import { useContext, useEffect } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import signUpImg from "../../assets/images/signUpImg.png";
import closebtnImg from "../../assets/images/close.png";
import completeImg from "../../assets/images/complete.png";
import { ProgressBar, Step } from "react-step-progress-bar";
import "react-step-progress-bar/styles.css";
import clipBoardBtnImg from "../../assets/images/clipb.png";

import styles from "./Signup.module.scss";
import styles_login from "../Login/Login.module.scss";

import LoaderImg from "../../assets/images/Loader.gif";
import { isMobileDevice } from "../../utils/getPlatformInfo";
import { validateEmail } from "../../utils/common.utils";
import OTPForm from "./partials/OTPForm/OTPForm";
import PersonalDetails from "./partials/PersonalDetails/PersonalDetails";
import { authContext } from "../../contexts/AuthContext/AuthContextProvider";
import { AuthManager } from "../../firebase/firebase";
import { openRoutes, whiteListCountries } from "../../AppConstants/Constants";

const Signup = () => {
  const {
    toggleSignInbtn,
    handlePhoneNumber,
    state,
    updateMultipleState,
    resetState,
    handleLoading,
    toggleSignUpScreens,
    handleFormDetails,
    closeSignUpModal,
    alreadyRegistered,
  } = useContext(authContext);
  const {
    error,
    formDetails,
    loading,
    showProfile,
    showOTPScreen,
    showPersonalDetailsScreen,
  } = state;
  const { firstName, lastName, email, phoneNumber } = formDetails;

  useEffect(() => {
    window.rr = () => handleLoading(false);
  }, []);

  const handleNextBtn = async (e) => {
    e.preventDefault();
    handleLoading(true);

    if (!validateEmail(formDetails.email)) {
      updateMultipleState({ error: "*Enter a valid email." });
      return;
    }
    if (
      !formDetails.phoneNumber ||
      !isValidPhoneNumber(formDetails.phoneNumber.trim())
    ) {
      updateMultipleState({ error: "*Enter a valid number." });
      handleLoading(false);
      return;
    }
    try {
      let response = await AuthManager.checkUserExists(formDetails);

      if (response.status) {
        handleLoading(false);
        updateMultipleState({ error: response.message });

        return;
      } else {
        handleLoading(false);
        toggleSignUpScreens({ type: "showotp", value: true });
      }
    } catch (error) {
      handleLoading(false);
      updateMultipleState({ error: "*Some internal error occurred." });
      return;
    }
  };

  const onError = (status, clearSuggestions) => {
    if (status === "ZERO_RESULTS") {
      updateMultipleState({ error: "No City Found" });
    }

    clearSuggestions();
  };
  const exists = openRoutes.some((hideRoute) =>
    window.location.pathname.includes(hideRoute)
  );
  if (alreadyRegistered) {
    return (
      <div className={`modalOverlayWithBlur ${styles_login["container"]}`}>
        <div className={`text-align-center ${styles_login["box"]}`}>
          <h1 className={styles_login["not-registered-heading"]}>
            Already Registered
          </h1>
          <div
            className={styles_login["signin-form"]}
            style={{ alignItems: "center" }}
          >
            <div className={styles_login["not-registered"]}>
              It seems that{" "}
              <sapn className={styles_login["not-registered-number"]}>
                {formDetails.phoneNumber}
              </sapn>
              <br />
              is already registered with us.
            </div>
            <div className={styles_login["not-registered-img"]}>
              <img src={clipBoardBtnImg} alt="" />
            </div>
            <div>Would you like to SignIn ?</div>
            <div className={styles_login["formbtns"]}>
              <button
                onClick={toggleSignInbtn}
                className={`btn ${styles_login["submit-btn"]}`}
              >
                SignIn
              </button>
              {!exists && (
                <button
                  className={`btn ${styles_login["notnow-btn"]}`}
                  onClick={resetState}
                >
                  Not Now
                </button>
              )}
            </div>
          </div>
          {!exists && (
            <div onClick={resetState} className={styles_login["closeBtn"]}>
              <img src={closebtnImg} alt="close" />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`modalOverlayWithBlur ${styles["container"]}`}>
      <div className={styles["box"]}>
        {/* left */}
        <div className={styles["left"]}>
          <div className={styles["progress"]}>
            <ProgressBar
              percent={showOTPScreen ? 25 : showPersonalDetailsScreen ? 50 : 10}
              filledBackground="#EB4548"
            >
              <Step transition="scale">
                {({ accomplished }) => <div className={styles["step"]}></div>}
              </Step>
              <Step transition="scale">
                {({ accomplished }) => (
                  <div className={styles["step"]}>
                    <div
                      className={`${styles["stepName"]} ${
                        accomplished && styles["stepNameVerified"]
                      }`}
                    >
                      REGISTER
                    </div>
                    {accomplished && (
                      <img
                        className={styles["stepImg"]}
                        src={completeImg}
                        alt=""
                      />
                    )}
                  </div>
                )}
              </Step>
              <Step transition="scale">
                {({ accomplished }) => (
                  <div className={styles["step"]}>
                    <div
                      className={`${styles["stepName"]} ${
                        accomplished && styles["stepNameVerified"]
                      }`}
                    >
                      VERIFY
                    </div>
                    {accomplished && (
                      <img
                        className={styles["stepImg"]}
                        src={completeImg}
                        alt=""
                      />
                    )}
                  </div>
                )}
              </Step>
              <Step transition="scale">
                {({ accomplished }) => (
                  <div className={styles["step"]}>
                    <div
                      className={`${styles["stepName"]} ${
                        accomplished && styles["stepNameVerified"]
                      }`}
                    >
                      PERSONAL DETAILS
                    </div>
                    {accomplished && (
                      <img
                        className={styles["stepImg"]}
                        src={completeImg}
                        alt=""
                      />
                    )}
                  </div>
                )}
              </Step>
              <Step transition="scale">
                {({ accomplished }) => <div className={styles["step"]}></div>}
              </Step>
            </ProgressBar>
          </div>
          {showProfile && (
            <div className={styles["profileContainer"]}>
              <h1>Let’s get started</h1>
              <form onSubmit={handleNextBtn} className={styles["signup-form"]}>
                <div className={styles["names"]}>
                  <div className={styles["input-group"]}>
                    <label htmlFor="fName">Name</label>
                    <input
                      id="fName"
                      name="fName"
                      className="form-control"
                      type="text"
                      placeholder="First Name"
                      value={firstName}
                      onChange={(e) =>
                        handleFormDetails({ firstName: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className={styles["input-group"]}>
                    <input
                      name="lName"
                      className="form-control"
                      type="text"
                      placeholder="Last Name"
                      value={lastName}
                      onChange={(e) =>
                        handleFormDetails({ lastName: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className={styles["input-group"]}>
                  <label htmlFor="email">Email</label>
                  <input
                    id="email"
                    name="email"
                    className="form-control"
                    type="email"
                    placeholder="Enter Your Email Id"
                    value={email}
                    onChange={(e) =>
                      handleFormDetails({ email: e.target.value })
                    }
                    required
                  />
                </div>
                <div className={styles["input-group"]}>
                  <label htmlFor="phone">Mobile Number</label>
                  <PhoneInput
                    style={{ marginTop: "0.8rem" }}
                    defaultCountry={whiteListCountries[0]}
                    international
                    addInternationalOption={false}
                    countryCallingCodeEditable={false}
                    limitMaxLength
                    // countries={whiteListCountries}
                    withCountryCallingCode
                    className="form-control"
                    name="phoneNumber"
                    value={phoneNumber}
                    id="phone"
                    placeholder="Enter Mobile Number"
                    onChange={(value) => handlePhoneNumber(value)}
                    required
                    onFocus={() => {
                      updateMultipleState({ error: "" });
                      handleLoading(false);
                    }}
                  />
                </div>
                {error && (
                  <div className={"error"}>
                    <span>{error}</span>
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "2rem",
                  }}
                >
                  <button
                    style={{ width: isMobileDevice ? "50%" : "100%" }}
                    disabled={loading}
                    className={`btn ${styles["next-btn"]}`}
                  >
                    {loading ? (
                      <img src={LoaderImg} alt="" height="100%" />
                    ) : (
                      "Next"
                    )}
                  </button>
                  {isMobileDevice && (
                    <button
                      style={{
                        width: "50%",
                        background: "transparent",
                        border: "1px solid #eb4547",
                      }}
                      onClick={closeSignUpModal}
                      className={`btn ${styles["next-btn"]}`}
                    >
                      Cancel
                    </button>
                  )}
                </div>
              </form>
            </div>
          )}
          {showOTPScreen && <OTPForm old />}
          {showPersonalDetailsScreen && <PersonalDetails old />}
        </div>
        {/* right */}
        <div className={styles["right"]}>
          <img src={signUpImg} alt="" />
        </div>
        {!isMobileDevice && !exists && (
          <div onClick={closeSignUpModal} className={styles["closeBtn"]}>
            <img src={closebtnImg} alt="close" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Signup;
